export class MixItem {
  constructor(data) {
    this.airPercent = data.airPercent;
    this.itemCode = data.code;
    this.itemDescription = data.description;
    this.itemExternalDescription = data.externalDescription;
    this.itemId = data.id;
    this.locationId = data.locationId;
    this.maxDropSize = data.maxDropSize;
    this.mixingTime = data.mixingTime;
    this.slumpString = data.slumpString;
    this.slump = data.slump;
    this.taxable = data.taxable;
    this.unitCode = data.unitCode;
    this.unitId = data.unitId;
    this.unitSymbol = data.unitSymbol;
    this.waterCementRatio = data.waterCementRatio;
  }
}
